import svg from "./dataset-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const DatasetIcon = makeSvgIcon(svg, (theme) => theme.palette.data.main);

export default DatasetIcon;
